import React, { useCallback, useState } from 'react'

export default function Dropdown({ header, children, headerClassName }) {

    const [height, setHeight] = useState(0)
    const [open, setOpen] = useState(false)

    const ref = useCallback((el) => {
        if (el !== null) {
            setHeight(el.clientHeight)
        }
    },[])

    return (
        <div>
            <button className={'button ' + headerClassName} onClick={() => setOpen((state) => !state)}>
                {header}
            </button>
            <div style={{ height: (open ? `${height}px` : '0px') }} className='overflow-hidden animate-height' >
                <div style={{ opacity: (open ? 1 : 0) }} className={(open ? 'animate-open-opacity' : 'animate-closed-opacity')} ref={ref}>
                    {children}
                </div>
            </div>
        </div>
    )
}